import { useFetchEvents } from '@entities/event';
import InputSearch from '@shared/ui/input-search';
import { useEffect, useRef } from 'react';

interface SearchEventProps {
  searchValue: string;
  setSearchValue: React.Dispatch<React.SetStateAction<string>>;
}

export const SearchEvent = ({ searchValue, setSearchValue }: SearchEventProps) => {
  const { handleSearchChange } = useFetchEvents();
  const timerDebounceRef = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    return () => {
      clearTimeout(timerDebounceRef.current);
    };
  }, []);

  const handleDebounceScroll = () => {
    if (timerDebounceRef.current) {
      clearTimeout(timerDebounceRef.current);
    }

    timerDebounceRef.current = setTimeout(() => {
      handleSearchChange(searchValue);
    }, 1500);
  };

  const changeHandler = (value: string) => {
    setSearchValue(value);
    handleDebounceScroll();
  };

  return (
    <InputSearch
      searchValue={searchValue}
      changeValue={changeHandler}
      clearHandler={() => setSearchValue('')}
      searchHandler={() => handleSearchChange(searchValue)}
    />
  );
};
